import React from 'react';
import { SideInfoDevopsOptionsType } from '../../../../../model';
import {
  Layout,
  SideInformationComponent
} from '../../side-information-component';
import {
  FREE_EDITION_LABEL_KEY,
  getFeaturesList
} from '../../utility/sign-up-layout-container';

export function SideInfoDevops({
  labels,
  productKeys,
  analyticsTrack,
  formExistingSiteShown
}: SideInfoDevopsOptionsType) {
  const layout: Layout = 'devops';
  const edition = FREE_EDITION_LABEL_KEY.toLowerCase();

  const featuresList = getFeaturesList({
    labels,
    productKey: productKeys[0].product,
    products: productKeys,
    featuresListEditionLabelKey: edition,
    migrationData: undefined
  });

  return (
    <SideInformationComponent
      layout={layout}
      edition={edition}
      productKeys={productKeys}
      hideLogoContent={true}
      featuresList={featuresList}
      sideInfoHeader=""
      trialDurationNewSite=""
      trialDurationExistingSite=""
      imgSource=""
      isMobile={false}
      analyticsTrack={analyticsTrack}
      isExistingSiteFormShown={formExistingSiteShown}
    />
  );
}
